module.exports = __webpack_public_path__ + "static/media/PODGestion.8ffdb1ad.webp";